import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ReactNode } from 'react';

interface MobilePageHeaderProps {
  title: string;
  icon?: ReactNode;
  backPath?: string;
  onBack?: () => void;
}

export const MobilePageHeader = ({ title, icon, backPath, onBack }: MobilePageHeaderProps) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else if (backPath) {
      navigate(backPath);
    } else {
      navigate(-1);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-40 md:hidden">
      <div className="flex items-center justify-between px-4 py-3 backdrop-blur-xl bg-black/80 border-b border-white/10">
        <button
          onClick={handleBack}
          className="flex items-center gap-2 text-white/80 hover:text-white transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
        </button>
        
        <div className="flex items-center gap-2">
          {icon}
          <h1 className="text-lg font-semibold text-white">{title}</h1>
        </div>
        
        {/* Spacer for centering */}
        <div className="w-5" />
      </div>
    </header>
  );
};
